export const messages = {
  socketClosed: 'WebSocket closed',
  noDeviceFound: 'No devices found :(',
  socketError: 'WebSocket error occurred',
  noPatientSelected: 'No patient selected',
  macIdNotFound: 'Device MAC ID not found',
  patientIdNotFound: 'Patient ID not found',
  disconnectedByUser: 'Disconnected by user',
  websocketConnection: 'WebSocket connection',
  fileDownloadFailed: 'Failed to download file.',
  deviceNotFound: 'Device not found in the list',
  websocketClosureCode: 'Websocket closure code:',
  fetchBedsFailure: 'Failed to fetch bed details.',
  invalidMacAddress: 'Invalid MAC address format:',
  unknownMessageReceived: 'Unknown message received!',
  websocketErrorObserved: 'WebSocket error observed:',
  socketConnected: 'WebSocket connected successfully',
  patientDetailsNotFound: 'Patient details not found.',
  searchPatientError: 'Failed to search for your query.',
  websocketConnectionClosed: 'WebSocket connection closed.',
  socketCreationError: 'Error creating WebSocket connection',
  websocketNotOpen: 'WebSocket is not open. Message not sent:',
  websocketCloseError: 'Error while closing existing WebSocket:',
  failedToFetchMedications: 'Failed to fetch all visit medications.',
  failedToDiscontinueMedication: 'Failed to discontinue medication.',
  socketAlreadyConnected: 'WebSocket already connected or connecting.',
  vitalAlertApiFailure: 'Failed to send vital alert notification. Error: ',
  socketConnectionReattempt: 'Attempting to reconnect Prorithm WebSocket...',
  careplanNotificationFailure: 'Failed to send carelpan notification. Error: ',
  fetchMedicationAdministrationFailure:
    'Failed to fetch medication administration.',
  careplanApiFailure:
    'Unable to get doctor keycloak id. Failed to send careplan notification.',
  websocketReconnect:
    'Websocket closed abnormally. Reconnecting to WebSocket server...',
}
